<template>
  <div class="modsettings" v-show="showsettings">
    <div class="modsettings__back" @click="$parent.setShowsettings"></div>
    <div class="modsettings__body">
      <div class="instructions">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {}
  },
  props: {
    component: {
      default: ''
    },
    showsettings: {
      default: false
    }
  },
  methods: {}
}
</script>